import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-documents-pending',
  templateUrl: './documents-pending.component.html',
  styleUrls: ['./documents-pending.component.scss']
})
export class DocumentsPendingComponent implements OnInit {
  authoringContentData: any;
  name: any;
  email: any;
  infoApiFailed: boolean;
  title: string;
  affiliationType: string;
  status: string;
  navigateToHome: boolean;

  constructor(private router: Router,public utilsSvc: UtilsService,public manageLineService: ManageLineService) { }

  ngOnInit(): void {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
  }

  redirectToMilitaryFAQ(){
    window.open(this.authoringContentData.militaryUploadDocument.faqLink, '_blank ');
  }

  close(){
    this.manageLineService.close();
    if (this.navigateToHome) {
      this.router.navigate(['/apps/tfb_acctmgmt/account-management/home']);
    }
  }
}
